import { makeStyles } from "@material-ui/core/styles";
import Alert from "@material-ui/lab/Alert";
import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { CustomerGroupListItem } from "../../lib/models/CustomerGroupListItem";
import { Dispatch, StoreState } from "../../store";
import ConfirmationDialog from "../generic/ConfirmationDialog";

const useStyles = makeStyles({
  alert: {
    "& .MuiAlert-icon": {
      alignItems: "center",
    },
  },
});

interface Props {
  open: boolean;
  customerGroup: CustomerGroupListItem;
  onClose: () => void;
  onAbort: () => void;
  onConfirm: () => void;
}

const ChangeFilterSettingForCustomerGroupDialog = ({
  open,
  customerGroup,
  onClose,
  onAbort,
  onConfirm,
}: Props): JSX.Element => {
  const classes = useStyles();
  const dispatch = useDispatch<Dispatch>();
  const customerGroupFilter = useSelector(
    (state: StoreState) => state.customerGroupFilter
  );
  return (
    <ConfirmationDialog
      open={open}
      onClose={onClose}
      onConfirm={() => {
        dispatch.customerGroupList.editCustomerGroup({
          filterSettings: customerGroupFilter,
          customerGroupUuid: customerGroup.uuid,
        });
        dispatch.activeCustomerGroup.setActiveCustomerGroup({
          ...customerGroup,
          filterSettings: customerGroupFilter,
        });
        onConfirm();
      }}
      onAbort={onAbort}
      text={
        <Alert severity="warning" className={classes.alert}>
          <b>{`Beim Ändern der Filtereinstellungen werden sämtliche gespeicherte Exporte für die Kundengruppe ${customerGroup.groupName} gelöscht. Trotzdem ausführen?`}</b>
        </Alert>
      }
    />
  );
};

export default ChangeFilterSettingForCustomerGroupDialog;



// WEBPACK FOOTER //
// ./src/components/CustomerGroups/ChangeFilterSettingForCustomerGroupDialog.tsx